// removed by extract-text-webpack-plugin
module.exports = {"scroll":"_1tj9ak2g-XTsOJYPvbKHXJ","floating":"_2ypYKpJDomLq3ejMKdMZBJ","grey":"_2QOQaJRkfdfy7UKTaJ2XKI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/BoxScroll/style.css
// module id = 275
// module chunks = 42